/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Ryan Duffy
 */

export class NotificationModel {
  notificationId: string;
  notificationType: string;
  notificationSourceId: string;
  ownerId: string;
  created: Date;
  notificationRead: boolean;
  updated?: Date;
  notificationSourceName?: string;

  constructor(
    notificationId?: string,
    notificationType?: string,
    notificationSourceId?: string,
    ownerId?: string,
    created?: Date,
    notificationRead?: boolean,
    updated?: Date,
    notificationSourceName?: string
  ) {
    this.notificationId = notificationId;
    this.notificationType = notificationType;
    this.notificationSourceId = notificationSourceId;
    this.ownerId = ownerId;
    this.created = created;
    this.notificationRead = notificationRead;
    this.updated = updated;
    this.notificationSourceName = notificationSourceName;
  }

  toJson(): Object {
    const object = {
      notification_id: this.notificationId,
      notification_type: this.notificationType,
      notification_source_id: this.notificationSourceId,
      owner_id: this.ownerId,
      created: this.created,
      notification_read: this.notificationRead,
      updated: this.updated,
      notification_source_name: this.notificationSourceName,
    };
    Object.keys(object).forEach(
      (k) =>
        !object[k] && typeof object[k] !== 'boolean' && object[k] !== undefined && delete object[k]
    );
    return object;
  }

  fromJson(input: any): NotificationModel {
    return new NotificationModel(
      input['notification_id'],
      input['notification_type'],
      input['notification_source_id'],
      input['owner_id'],
      input['created'],
      input['notification_read'],
      input['updated'],
      input['notification_source_name']
    );
  }
}
